module.exports = __webpack_public_path__ + "static/media/1hd-music-television.c69dfed7.png";